import { SampleTrackerViewType } from "@via/pages/sample-trackers/sample-trackers-filter";
import { SelectOption } from "@via/utils/interfaces";
import { ReactNode } from "react";

interface FormatOptionContext {
  context: "menu" | "value";
}

export function formatSharedTrackerOptionLabel(
  option: SelectOption,
  { context }: FormatOptionContext,
  selectedTrackerViewType: SampleTrackerViewType
): ReactNode {
  const owner = option.metadata?.owner as string;

  if (
    selectedTrackerViewType !== SampleTrackerViewType.Shared ||
    !owner ||
    !option.label
  ) {
    return option.label;
  }

  if (context === "value") return `${option.label} (owned by ${owner})`;

  return (
    <div className="flex flex-col">
      <span>{option.label}</span>
      <span className="text-xs text-gray-500">Owned by {owner}</span>
    </div>
  );
}
